/**
 * @desc 财务画像布局
 * @author caoyx
 */
import styles from './frame.scss';
import React, { PureComponent } from 'react';
import cns from 'classnames';
import Nav from '../nav/Nav';
import Location from '../location/Location';
import CompanyInfo from '../companyInfo/CompanyInfo';
import GoTop from '../goTop/GoTop';
import LogModal from '../logModal/LogModal';

export default class Frame extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHideCompanyInfo: window.isHideCompanyInfo,
            visible: false,
            modalKey: +new Date()
        };
    }

    handleToggle = () => {
        window.isHideCompanyInfo = !window.isHideCompanyInfo;
        this.setState({
            isHideCompanyInfo: !!window.isHideCompanyInfo
        });
    };

    // 弹框操作
    showModal = () => {
        this.setState({ visible: true, modalKey: +new Date() });
    };

    hideModal = () => {
        this.setState({ visible: false });
    };

    render() {
        const { isHideCompanyInfo, visible, modalKey } = this.state;

        return (
            <div className={styles.layout}>
                <Location />

                <div className={styles.mainContainer}>
                    <div className={styles.topContent}>
                        <CompanyInfo className={isHideCompanyInfo ? 'hide' : ''}/>
                        <Nav />
                        <div className={styles.handleIcons}>
                            <i
                                className={cns('iconfont', isHideCompanyInfo ? 'icon-xia' : 'icon-shang')}
                                onClick={this.handleToggle}>
                            </i>
                            <i className="iconfont icon-bianji" title="添加日志" onClick={this.showModal}> </i>
                        </div>
                    </div>

                    <div className={cns(styles.context, isHideCompanyInfo ? styles.collapse : '')}>
                        {this.props.children}
                    </div>
                </div>

                <GoTop />

                <LogModal
                    key={modalKey}
                    visible={visible}
                    onCancel={this.hideModal}
                />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/common/frame/Frame.jsx